;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Link from 'next/link';
import { ReactNode } from "react";
import { usePathname } from 'next/navigation';

import styles from './NavLink.module.scss';

interface NavLinkProps {
  ariaLabel?: string;
  children: ReactNode;
  className?: string;
  href: string;
  onClick?: () => void;
}

/**
 * A simple pass through to the Next Link component
 * that adds an active class when the href matches the current path
 * @param {string} ariaLabel
 * @param {ReactNode} children
 * @param {string} className
 * @param {string} href
 * @param {() => void} onClick
 * @returns {ReactNode}
*/
const NavLink = (props: NavLinkProps) => {
  const {
    ariaLabel,
    children,
    className,
    href,
    onClick,
  } = props;

  let classNames = styles.nav_link;

  if (className) {
    classNames += ` ${className}`;
  }

  const pathName = usePathname();

  if (pathName === href) {
    classNames += ` ${styles.is_active}`;
  }

  return (
    <Link href={href} className={classNames} onClick={onClick} prefetch={false} aria-label={ariaLabel}>
      {children}
    </Link>
  );
};

export default NavLink;
